import type { ReactNode } from 'react';
import { useSupportLink } from '@/hooks/use-support-link';

const LOOM_ID = '4c7a0bc0d1d4482797682d096ae78cb9';
const META_TUTORIAL = 'https://www.youtube.com/watch?v=nLWtC5dn7jM';
const META_CARD = 'https://www.youtube.com/watch?v=NUc2FcYgP5Y';

const LINK_CLS = 'text-info underline break-all hover:text-info/80';
const H_CLS = 'mb-1 font-medium text-text-primary';

function LoomEmbed(): ReactNode {
  return (
    <iframe
      className="aspect-video w-full rounded-lg"
      src={`https://www.loom.com/embed/${LOOM_ID}`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen"
      allowFullScreen
      title="Clase completa de wallet"
    />
  );
}

function ExternalLink({ href }: { href: string }): ReactNode {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={LINK_CLS}
    >
      {href}
    </a>
  );
}

export function Enlace1(): ReactNode {
  return (
    <div className="space-y-sm">
      <h3 className={H_CLS}>Enlace 1 — Clase completa (30 min)</h3>
      <LoomEmbed />
    </div>
  );
}

export function Enlace2(): ReactNode {
  return (
    <div className="space-y-1">
      <h3 className={H_CLS}>
        Enlace 2 — Paso a paso para crear tu wallet (MetaMask)
      </h3>
      <p className="text-text-tertiary">
        Puedes descargar la app de MetaMask desde el móvil o pc, como te sea más
        cómodo.
      </p>
      <ExternalLink href={META_TUTORIAL} />
    </div>
  );
}

export function Enlace3(): ReactNode {
  return (
    <div className="space-y-1">
      <h3 className={H_CLS}>
        Enlace 3 — Crear tarjeta física o virtual de MetaMask+
      </h3>
      <ExternalLink href={META_CARD} />
    </div>
  );
}

export function SupportLine(): ReactNode {
  const link = useSupportLink();
  const label = 'Escribe por WhatsApp a Luz';
  return (
    <p>
      Si tienes cualquier duda,{' '}
      {link ? (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className={LINK_CLS}
        >
          {label}
        </a>
      ) : (
        <span>{label}</span>
      )}{' '}
      del equipo de soporte.
    </p>
  );
}
